module.exports = __webpack_public_path__ + "assets/img/29_210_big.2bb45788.jpg";